import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, toRefs
} from 'vue';
import ProjectMinimalListItem from '@/views/project-forum/components/ProjectMinimalListItem.vue';
import { ProjectListProject } from '@/views/project-forum/models/ProjectForum';
import ProjectSelector from '@/views/project-forum/components/sidebar-actions/ProjectSelector.vue';
import MinusCircleIcon from '@/components/svg/minus-circle.svg?inline';
import useResponsiveness from '@/mixins/useResponsiveness';
import X from '@/components/svg-components/X.vue';
import { CompanyGuestListResponse } from '@/models/Company';
import useI18n from '@/mixins/useI18n';
import { useProjectGuests } from '../composables/useProjectGuests';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberProjectList',
  props: {
  member: {
    type: Object as PropType<CompanyGuestListResponse>,
    required: true,
  },
},
  emits: ['add-member-project', 'delete-member-project'],
  setup(__props, { emit }) {

const props = __props;





const { isMobileWidth } = useResponsiveness();
const { member } = toRefs(props);
const { t } = useI18n();

const projects = computed(() => member.value.projects);
const { projectList, projectName } = useProjectGuests();
const selectedProject = ref<ProjectListProject | null>(null);

const remainingProjectsList = computed(
  () => projectList.value.filter(
    (project) => !projects.value.some(
      (addedProject) => addedProject.id === project.id
    )
  )
);

const hasOpenProjects = computed(() => projectList.value.length > 0);
const hasAssignedProjects = computed(() => projects.value.length > 0);

const onSelectProject = (project: ProjectListProject) => {
  projectName.value = project.title;
  selectedProject.value = project;
  emit('add-member-project', project);
  projectName.value = '';
};

const canAssignProjects = computed(() => props.member?.active && props.member.userRegistrationStep !== 'NONE');
const projectSelectorPlaceholder = computed(() => {
  if (hasOpenProjects.value && !remainingProjectsList.value.length) {
    return t('project-guests.project-placeholder-all-assigned').toString();
  }
  return t('project-guests.project-placeholder').toString();
});

const projectSelectorHint = computed(() => {
  if (member.value.userRegistrationStep === 'NONE') {
    return t('project-guests.registration-pending').toString();
  }
  if (!member.value.active) {
    return t('project-guests.guest-deactivated').toString();
  }
  if (!hasOpenProjects.value && !hasAssignedProjects.value) {
    return t('project-guests.project-no-open-projects').toString();
  }
  return '';
});


return { __sfc: true,props, emit, isMobileWidth, member, t, projects, projectList, projectName, selectedProject, remainingProjectsList, hasOpenProjects, hasAssignedProjects, onSelectProject, canAssignProjects, projectSelectorPlaceholder, projectSelectorHint, ProjectMinimalListItem, ProjectSelector, MinusCircleIcon, X }
}

})